"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.idToColor = exports.Avatar = void 0;
const class_variance_authority_1 = require("class-variance-authority");
const react_1 = __importDefault(require("react"));
const utils_1 = require("../../lib/utils");
const defaultStyles = "tw-flex tw-shrink-0 tw-flex-col tw-items-center tw-justify-center tw-rounded-full tw-font-semibold tw-text-neutral-25";
function idToColor(id) {
    return [
        "yellow",
        "orange",
        "salmon",
        "pink",
        "fuchsia",
        "lavender",
        "purple",
        "navy",
        "blue",
        "turquoise",
    ][id % 10];
}
exports.idToColor = idToColor;
const avatarVariants = (0, class_variance_authority_1.cva)([defaultStyles], {
    variants: {
        size: {
            sm: "tw-h-5 tw-w-5 tw-text-[8px]",
            md: "tw-h-6 tw-w-6 tw-text-[10px]",
            lg: "tw-h-7 tw-w-7 tw-text-xs",
        },
        color: {
            yellow: "tw-bg-yellow-3",
            orange: "tw-bg-yellow-4",
            salmon: "tw-bg-orange-3",
            pink: "tw-bg-warning-200",
            fuchsia: "tw-bg-fuchsia-4",
            lavender: "tw-bg-purple-3",
            purple: "tw-bg-purple-4",
            navy: "tw-bg-primaryDim-400",
            blue: "tw-bg-blue-3",
            turquoise: "tw-bg-secondary-200",
        },
    },
    defaultVariants: {
        size: "md",
        color: "yellow",
    },
});
const Avatar = react_1.default.forwardRef(({ className, size, color, children, ...props }, ref) => {
    return (react_1.default.createElement("div", { className: (0, utils_1.cn)(avatarVariants({ size, color, className })), ref: ref, ...props }, children));
});
exports.Avatar = Avatar;
Avatar.displayName = "Avatar";
